module.exports = window['super-electron'];